/**
 * Unilar BF Categorias
 * Drag carousel até 1090px; acima disso a lista fica estática.
 */

class UnilarBfCategorias {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-bf-cats-track]');
    this.desktopMq = window.matchMedia('(min-width: 1091px)');
    this.drag = {
      active: false,
      moved: false,
      startX: 0,
      scrollLeft: 0,
      pointerId: null,
    };
    this.init();
  }

  canDrag() {
    return !this.desktopMq.matches;
  }

  init() {
    if (!this.track) return;

    const interactiveSelector = 'a, button';

    this.track.addEventListener('pointerdown', (event) => {
      if (!this.canDrag()) return;
      if (event.pointerType === 'touch') return;
      if (event.target instanceof Element && event.target.closest(interactiveSelector)) return;

      this.drag.active = true;
      this.drag.moved = false;
      this.drag.startX = event.clientX;
      this.drag.scrollLeft = this.track.scrollLeft;
      this.drag.pointerId = event.pointerId;
      this.track.classList.add('is-dragging');
      this.track.setPointerCapture(event.pointerId);
    });

    this.track.addEventListener('pointermove', (event) => {
      if (!this.drag.active || !this.canDrag()) return;
      const delta = event.clientX - this.drag.startX;
      if (Math.abs(delta) > 4) this.drag.moved = true;
      this.track.scrollLeft = this.drag.scrollLeft - delta;
    });

    const stopDrag = () => {
      if (!this.drag.active) return;
      if (this.drag.pointerId != null) {
        try {
          this.track.releasePointerCapture(this.drag.pointerId);
        } catch (error) {
          // Capture may already be released.
        }
      }
      this.drag.active = false;
      this.drag.pointerId = null;
      this.track.classList.remove('is-dragging');
    };

    this.track.addEventListener('pointerup', stopDrag);
    this.track.addEventListener('pointercancel', stopDrag);
    this.track.addEventListener(
      'click',
      (event) => {
        if (!this.drag.moved) return;
        event.preventDefault();
        event.stopPropagation();
        this.drag.moved = false;
      },
      true
    );
  }
}

function initUnilarBfCategorias() {
  document.querySelectorAll('[data-unilar-bf-cats]').forEach((section) => {
    if (!(section instanceof HTMLElement) || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    new UnilarBfCategorias(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUnilarBfCategorias);
} else {
  initUnilarBfCategorias();
}

document.addEventListener('shopify:section:load', initUnilarBfCategorias);
